export const AVAILABLE_DEVICE_TYPES = [
  { text: "Charge Controller", value: "CHARGE_CONTROLLER" },
  { text: "Weather Station", value: "WEATHER_STATION" },
  { text: "Iot Gateway", value: "IOT_GATEWAY" },
  { text: "Other", value: "OTHER" }
];
